import { storeCodes, fieldStoreCodeVulcan, fieldStoreCodeOutletVulcan, storeCodeOutletMapping } from "../../utils/constant";

export const StoreCodeOptionsHelper = ({ formFields, fieldName, fields }) => {
  if (fieldName !== fieldStoreCodeVulcan) return;

  if (!formFields[fieldStoreCodeVulcan].options) {
    formFields[fieldStoreCodeVulcan].options = storeCodes.map(storeCode => ({
      fields: {
        label: storeCode,
        value: storeCode
      }
    }));
    fields.options = formFields[fieldStoreCodeVulcan].options;
  }

    const selectedStoreCode =
    formFields &&
    formFields.storeCodeVulcan &&
    formFields.storeCodeVulcan.value;

  const mappedOutletCode = storeCodeOutletMapping[selectedStoreCode];

  if (
    formFields &&
    formFields[fieldStoreCodeOutletVulcan] &&
    mappedOutletCode
  ) {
    formFields[fieldStoreCodeOutletVulcan].value = mappedOutletCode;
  }
};